// Guard to prevent inline-handler errors if Bold isn't present on collections
(function ensureBoldStubs(){
    window.BOLD = window.BOLD || {};
    window.BOLD.BsubWidget = window.BOLD.BsubWidget || {};
    ['handleSelectionChange','handleToggleSubDetails'].forEach(name => {
      if (typeof window.BOLD.BsubWidget[name] !== 'function') {
        window.BOLD.BsubWidget[name] = () => { /* no-op on collections */ };
      }
    });
  })();

  (function () {
    const D = document;
  
    // Money helper ($12.34)
    const money = cents => `$${(cents / 100).toFixed(2)}`;
  
    function wireWidget(widget) {
      if (widget.__wired) return; widget.__wired = true;
  
      const productScript = widget.querySelector('script[data-bsub-product-json]');
      const form = widget.closest('.quick-buy-drawer')?.querySelector('form[is="product-form"]');
      if (!productScript || !form) return;
  
      const product = JSON.parse(productScript.textContent);
  
      // Current variant (quick-buy uses a single variant input)
      const variantId = Number(form.querySelector('input[name="id"]').value);
      const variant   = product.variants.find(v => v.id === variantId);
      const basePrice = variant?.price || product.price;
  
      // Map plan name -> plan id (e.g., "Month" -> 690828738844)
      const group = (product.selling_plan_groups || [])[0] || {};
      const plans = group.selling_plans || [];
      const percent = plans?.[0]?.price_adjustments?.[0]?.value || 0; // 15
  
      const planIdByName = {};
      plans.forEach(p => { planIdByName[p.name] = p.id; });
  
      // Map plan id -> per_delivery_price (from allocations on this variant)
      const perPriceByPlanId = {};
      (variant.selling_plan_allocations || []).forEach(a => {
        perPriceByPlanId[a.selling_plan_id] = a.per_delivery_price;
      });
  
      // Ensure hidden selling_plan input on the form
      let sp = form.querySelector('input[name="selling_plan"]');
      if (!sp) {
        sp = D.createElement('input');
        sp.type = 'hidden';
        sp.name = 'selling_plan';
        form.appendChild(sp);
      }
  
      // Fill right-hand price and add "(15% off $15.99)" next to the label
      widget.querySelectorAll('[data-bsub-delivery-frequency-option]').forEach(radio => {
        const freqName = radio.value;                           // "Month", "2 Months", ...
        const planId   = planIdByName[freqName];
        const perCents = perPriceByPlanId[planId] ?? Math.round(basePrice * (1 - percent/100));
  
        // Right price
        const priceEl = radio.closest('.bsub-option-container')?.querySelector('[data-bsub-per-delivery-price]');
        if (priceEl) priceEl.textContent = money(perCents);
  
        // Discount text next to the main label
        const main = radio.closest('.bsub-option-container')?.querySelector('.bsub-widget__main-text');
        if (main && !main.querySelector('.bsub-discount')) {
          const disc = D.createElement('span');
          disc.className = 'bsub-discount';
          disc.style.marginLeft = '6px';
          disc.textContent = `(${percent}% off ${money(basePrice)})`;
          main.appendChild(disc);
        }
      });
  
      // Show/hide frequency list and keep selling_plan in sync with selection
      function sync() {
        const groupChoice = widget.querySelector('[name="bsub-selling-plan-group"]:checked');
        const isOneTime = groupChoice && (groupChoice.value === 'once' || groupChoice.hasAttribute('data-bsub-purchase-option-one-time'));
  
        widget.querySelectorAll('.bsub-options-container').forEach(el => el.classList.toggle('bsub__hidden', !!isOneTime));
        if (isOneTime) {
          sp.value = '';
          return;
        }
  
        // ensure a frequency is selected
        let freq = widget.querySelector('[data-bsub-delivery-frequency-option]:checked');
        if (!freq) {
          freq = widget.querySelector('[data-bsub-delivery-frequency-option]');
          if (freq) freq.checked = true;
        }
        const planId = planIdByName[freq?.value];
        sp.value = planId || '';
      }
  
      sync();
      widget.addEventListener('change', e => {
        if (e.target.matches('[name="bsub-selling-plan-group"], [data-bsub-delivery-frequency-option]')) sync();
      });
    }
  
    function scan() {
      document.querySelectorAll('.quick-buy-drawer .bsub-widget').forEach(wireWidget);
    }
  
    document.addEventListener('DOMContentLoaded', scan);
    document.addEventListener('quick-buy:open', scan);
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  })();
  
    (function(){
      function applyOptionsVisibility(widget){
        const selected = widget.querySelector('[name="bsub-selling-plan-group"]:checked');
        const isSubscribe = !!selected && !selected.hasAttribute('data-bsub-purchase-option-one-time');
    
        widget.querySelectorAll('.bsub-options-container').forEach(el => {
          // hide when one-time is active; show when subscribe is active
          el.classList.toggle('bsub__hidden', !isSubscribe);
          // hard fallback in case theme CSS overrides
          el.style.display = isSubscribe ? '' : 'none';
        });
      }
    
      function wire(widget){
        if (!widget || widget.__optsWired) return; widget.__optsWired = true;
        applyOptionsVisibility(widget);
    
        // Re-evaluate whenever the purchase option radio changes
        widget.addEventListener('change', (e) => {
          if (e.target.matches('[name="bsub-selling-plan-group"]')) {
            applyOptionsVisibility(widget);
          }
        });
    
        // Some themes don’t bubble the radio change from header clicks reliably
        widget.querySelectorAll('.bsub-widget__group-label').forEach(lbl => {
          lbl.addEventListener('click', () => setTimeout(() => applyOptionsVisibility(widget), 0));
        });
      }
    
      const scan = () => document
        .querySelectorAll('.quick-buy-drawer .bsub-widget')
        .forEach(wire);
    
      document.addEventListener('DOMContentLoaded', scan);
      new MutationObserver(scan).observe(document.documentElement, { childList:true, subtree:true });
    })();
   
      (function(){
        const money = c => `$${(c/100).toFixed(2)}`;
      
        function ensureDropdown(widget){
          if (!widget || widget.__dropdownWired) return;
          const optionsWrap = widget.querySelector('.bsub-options-container');
          const fieldset    = widget.querySelector('.bsub-widget__delivery-fieldset');
          if (!optionsWrap || !fieldset) return;
      
          // Build once
          widget.__dropdownWired = true;
      
          // Read product pricing for safe fallbacks
          const productJSON = widget.querySelector('script[data-bsub-product-json]');
          let product = {};
          try { product = JSON.parse(productJSON?.textContent || '{}'); } catch(e){}
          const form      = widget.closest('.quick-buy-drawer')?.querySelector('form[is="product-form"]');
          const variantId = Number(form?.querySelector('input[name="id"]')?.value);
          const variant   = (product.variants || []).find(v => v.id === variantId) || {};
          const basePrice = Number(variant.price ?? product.price ?? 0);
          const group     = (product.selling_plan_groups || [])[0] || {};
          const plans     = group.selling_plans || [];
          const percent   = Number(plans?.[0]?.price_adjustments?.[0]?.value || 0);
      
          const perPriceByPlanId = {};
          (variant.selling_plan_allocations || []).forEach(a => {
            perPriceByPlanId[a.selling_plan_id] = a.per_delivery_price;
          });
      
          // Create dropdown UI
          const selectId = 'bsub-drop-' + (product.id || Math.floor(Math.random()*1e6));
          const dropWrap = document.createElement('div');
          dropWrap.className = 'bsub-dropdown-wrap';
      
          const label = document.createElement('label');
          label.setAttribute('for', selectId);
          label.className = 'bsub-dropdown-label';
          label.textContent = 'Delivery Frequency';
      
          const select = document.createElement('select');
          select.id = selectId;
          select.className = 'bsub-dropdown-select';
      
          // Collect radios → options
          const radios = Array.from(widget.querySelectorAll('[data-bsub-delivery-frequency-option]'));
          radios.forEach(radio => {
            const optEl = radio.closest('.bsub-option-container');
            const name  = (radio.value || '').trim(); // "Month", "2 Months", ...
            if (!name) return;
      
            // price text: prefer DOM-rendered, fallback to computed
            let priceText = optEl?.querySelector('[data-bsub-per-delivery-price]')?.textContent?.trim();
            if (!priceText) {
              // find plan id by name
              const plan = plans.find(p => (p.name||'').trim() === name);
              let cents  = perPriceByPlanId[plan?.id];
              if (typeof cents !== 'number') cents = Math.round(basePrice * (1 - percent/100));
              priceText = money(cents);
            }
      
            const option = document.createElement('option');
            option.value = name;
            option.textContent = `${name} — ${priceText} / delivery`;
            select.appendChild(option);
          });
      
          // Insert after legend, then hide the big grid
          const legend = fieldset.querySelector('legend');
          if (legend && legend.nextSibling) {
            legend.parentNode.insertBefore(dropWrap, legend.nextSibling);
          } else {
            fieldset.insertBefore(dropWrap, fieldset.firstChild);
          }
          dropWrap.appendChild(label);
          dropWrap.appendChild(select);
      
          fieldset.classList.add('bsub--dropdown-mode'); // CSS will hide the tiles
      
          // Sync: select -> radio (Bold listens to radio change)
          select.addEventListener('change', () => {
            const val = select.value;
            const radio = widget.querySelector(`[data-bsub-delivery-frequency-option][value="${CSS.escape(val)}"]`);
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
      
          // Sync: radio -> select (if Bold flips selection)
          widget.addEventListener('change', e => {
            if (e.target.matches('[data-bsub-delivery-frequency-option]')) {
              const v = (e.target.value || '').trim();
              if (v && select.value !== v) select.value = v;
            }
            if (e.target.matches('[name="bsub-selling-plan-group"]')) {
              // Disable dropdown when One-time is active; enable for Subscribe
              const isOneTime = e.target.hasAttribute('data-bsub-purchase-option-one-time') || e.target.value === 'once';
              select.disabled = isOneTime;
            }
          });
      
          // Initial state
          const checkedRadio = widget.querySelector('[data-bsub-delivery-frequency-option]:checked');
          if (checkedRadio) select.value = checkedRadio.value;
          // Disable if one-time is selected at start
          const activePO = widget.querySelector('[name="bsub-selling-plan-group"]:checked');
          const isOneTime = !!activePO && (activePO.value === 'once' || activePO.hasAttribute('data-bsub-purchase-option-one-time'));
          select.disabled = isOneTime;
        }
      
        function scan(){
          document.querySelectorAll('.quick-buy-drawer .bsub-widget').forEach(ensureDropdown);
        }
      
        document.addEventListener('DOMContentLoaded', scan);
        new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
      })();
   
        (function () {
          function wireCollapse(widget) {
            if (!widget || widget.__collapseWired) return;
            const btn  = widget.querySelector('.bsub-widget__toggle-details-btn');
            const wrap = widget.querySelector('[data-bsub-collapsible-wrapper]');
            if (!btn || !wrap) return;
            widget.__collapseWired = true;
        
            // Start closed
            btn.classList.add('bsub-widget__toggle-details-btn--closed');
            wrap.classList.add('bsub__collapsible-wrapper--closed');
            btn.setAttribute('aria-expanded','false');
            wrap.setAttribute('aria-hidden','true');
        
            btn.addEventListener('click', function (e) {
              // prevent Bold's inline onclick from double-toggling
              e.preventDefault();
              e.stopImmediatePropagation();
        
              const currentlyClosed = btn.classList.contains('bsub-widget__toggle-details-btn--closed');
              const newClosed = !currentlyClosed; // clicking toggles
        
              // Button class: add when closed, remove when open
              btn.classList.toggle('bsub-widget__toggle-details-btn--closed', newClosed);
        
              // Wrapper class: add when closed, remove when open
              wrap.classList.toggle('bsub__collapsible-wrapper--closed', newClosed);
        
              // A11y
              btn.setAttribute('aria-expanded', String(!newClosed));
              wrap.setAttribute('aria-hidden',   String(newClosed));
            });
          }
        
          function scan() {
            document
              .querySelectorAll('.quick-buy-drawer .bsub-widget')
              .forEach(wireCollapse);
          }
        
          document.addEventListener('DOMContentLoaded', scan);
          new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
        })();
       
          (function () {
            const fmt = (cents, code='USD') =>
              new Intl.NumberFormat('en-US', { style:'currency', currency: code }).format(cents/100);
          
            function updateDynamic(widget){
              const dynWrap = widget.querySelector('.bsub-widget__dynamic-discount-container');
              const dynText = widget.querySelector('.bsub-widget__dynamic-discount-text');
              if (!dynWrap || !dynText) return;
          
              // Hide if One-time is selected
              const po = widget.querySelector('[name="bsub-selling-plan-group"]:checked');
              const isSub = !!po && po.value !== 'once';
              if (!isSub) {
                dynText.textContent = '';
                dynWrap.classList.add('bsub__hidden');
                return;
              }
          
              // Pull product + variant + plans from Bold’s JSON
              let product = {};
              try {
                product = JSON.parse(widget.querySelector('script[data-bsub-product-json]')?.textContent || '{}');
              } catch(e){}
          
              const form      = widget.closest('.quick-buy-drawer')?.querySelector('form[is="product-form"]');
              const variantId = Number(form?.querySelector('input[name="id"]')?.value);
              const variant   = (product.variants || []).find(v => v.id === variantId) || {};
              const group     = (product.selling_plan_groups || [])[0] || {};
              const plans     = group.selling_plans || [];
              const allocs    = variant.selling_plan_allocations || [];
          
              // Which frequency is checked?
              const freqRadio = widget.querySelector('[data-bsub-delivery-frequency-option]:checked');
              if (!freqRadio) { dynWrap.classList.add('bsub__hidden'); dynText.textContent=''; return; }
          
              // Match plan by name (e.g., "Month", "2 Months", ...)
              const plan = plans.find(p => (p.name||'').trim() === (freqRadio.value||'').trim());
              if (!plan) { dynWrap.classList.add('bsub__hidden'); dynText.textContent=''; return; }
          
              const alloc = allocs.find(a => a.selling_plan_id === plan.id);
              const baseCents = Number(variant.price ?? product.price ?? 0);
              const perCents  = Number(alloc?.per_delivery_price ??
                                 Math.round(baseCents * (1 - (plan.price_adjustments?.[0]?.value||0)/100)));
          
              const pads = plan.price_adjustments || [];
              if (!pads.length) { dynWrap.classList.add('bsub__hidden'); dynText.textContent=''; return; }
          
              // Currency (fallback to USD)
              const currency = 'USD';
          
              // If you had real “dynamic” tiers, show both initial and subsequent;
              // otherwise show a single flat message.
              let message = '';
              if (pads.length > 1 || pads.some(p => p.order_count)) {
                const first = pads[0];
                const next  = pads[1] || {};
                const initialFixed   = baseCents - perCents;
                const subsequentPct  = Number(next.value || first.value);
                const subsequentFix  = Math.round(baseCents * (subsequentPct/100));
                const afterCount     = Number(next.order_count || 1);
                message = `Save ${first.value}% (${fmt(initialFixed, currency)}) initially, then ${subsequentPct}% (${fmt(subsequentFix, currency)}) after ${afterCount} order${afterCount>1?'s':''}.`;
              } else {
                const pct   = Number(pads[0].value || 0);
                const fixed = baseCents - perCents;
                message = `Save ${pct}% (${fmt(fixed, currency)}) each delivery.`;
              }
          
              dynText.textContent = message;
              dynWrap.classList.remove('bsub__hidden');
            }
          
            function wire(widget){
              if (widget.__dynWired) return;
              widget.__dynWired = true;
          
              // Update when user switches purchase option or frequency
              widget.addEventListener('change', (e) => {
                if (e.target.matches('[name="bsub-selling-plan-group"], [data-bsub-delivery-frequency-option]')) {
                  updateDynamic(widget);
                }
              });
          
              // Initial render
              updateDynamic(widget);
            }
          
            function scan(){
              document.querySelectorAll('.quick-buy-drawer .bsub-widget').forEach(wire);
            }
          
            document.addEventListener('DOMContentLoaded', scan);
            new MutationObserver(scan).observe(document.documentElement, { childList:true, subtree:true });
          })();
        
          
          
            (() => {
              const SCOPE = 'quick-buy-drawer .bsub-widget';
              const MARK  = 'data-bsub-labels-updated';
            
              function formatMoney(cents, format) {
                if (cents == null) return '';
                // Prefer Shopify.formatMoney if present
                try {
                  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
                    return Shopify.formatMoney(cents, format || '${{amount}}');
                  }
                } catch (e) {}
                // Fallback: Intl
                const currency =
                  (window?.Shopify?.currency?.active) ||
                  document.querySelector('meta[itemprop="priceCurrency"]')?.getAttribute('content') ||
                  'USD';
                try {
                  return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
                } catch (e) {
                  // Absolute last resort
                  return `$${(cents / 100).toFixed(2)}`;
                }
              }
            
              function updateLabels(root) {
                if (root.hasAttribute(MARK)) return;
            
                const productJSONEl = root.querySelector('[data-bsub-product-json]');
                const moneyFmt = root.querySelector('script[data-bsub-money-format]')?.getAttribute('data-bsub-money-format') || '${{amount}}';
                if (!productJSONEl) return;
            
                const product = JSON.parse(productJSONEl.textContent || '{}');
                const variant = (product.variants && product.variants[0]) || {};
                // Regular price cents (prefer variant.price if present)
                const regularCents =
                  (typeof variant.price === 'number' ? variant.price : null) ??
                  (typeof product.price === 'number' ? product.price : null) ??
                  (typeof product.price_min === 'number' ? product.price_min : null);
            
                const groupId = root.querySelector('.bsub-options-container')?.getAttribute('data-bsub-selling-plan-group-id');
                const group = (product.selling_plan_groups || []).find(g => g.id === groupId) || (product.selling_plan_groups || [])[0];
                if (!group) return;
            
                const planByName = Object.create(null);
                const planById   = Object.create(null);
                (group.selling_plans || []).forEach(p => { planByName[p.name] = p; planById[p.id] = p; });
            
                const allocations = (variant.selling_plan_allocations || []);
            
                function perDeliveryFor(plan) {
                  // 1) Direct per_delivery_price from allocations (best source)
                  const alloc = allocations.find(a => a.selling_plan_id === plan.id);
                  if (alloc && typeof alloc.per_delivery_price === 'number') return alloc.per_delivery_price;
            
                  // 2) Compute from discount if allocation not available yet
                  if (typeof regularCents === 'number' && plan.price_adjustments?.length) {
                    const adj = plan.price_adjustments[0];
                    if (adj.value_type === 'percentage') {
                      const pct = Math.max(0, Math.min(100, Number(adj.value) || 0));
                      return Math.round(regularCents * (100 - pct) / 100);
                    }
                    if (adj.value_type === 'fixed_amount') {
                      return Math.max(0, regularCents - (Number(adj.value) || 0));
                    }
                    if (adj.value_type === 'price') {
                      return Number(adj.value) || null;
                    }
                  }
                  return null;
                }
            
                // Update inline cards
                root.querySelectorAll('.bsub-option-container').forEach(card => {
                  const name = card.getAttribute('data-bsub-option');
                  const plan = planByName[name];
                  if (!plan) return;
            
                  const perCents = perDeliveryFor(plan);
                  // % off (prefer the plan’s declared percentage)
                  let pct = plan.price_adjustments?.[0]?.value_type === 'percentage'
                    ? Number(plan.price_adjustments[0].value) || null
                    : (perCents != null && regularCents != null
                        ? Math.round((1 - perCents / regularCents) * 100)
                        : null);
            
                  const main = card.querySelector('.bsub-widget__main-text');
                  if (main && pct != null && regularCents != null) {
                    main.textContent = `${name} (${pct}% off ${formatMoney(regularCents, moneyFmt)})`;
                  }
            
                  const priceSpan = card.querySelector('[data-bsub-per-delivery-price]');
                  if (priceSpan && perCents != null) {
                    priceSpan.textContent = formatMoney(perCents, moneyFmt);
                  }
                });
            
                // Update dropdown options, if using the compact select UI
                const select = root.querySelector('.bsub-dropdown-select');
                if (select) {
                  Array.from(select.options).forEach(opt => {
                    const plan = opt.dataset.planId ? planById[Number(opt.dataset.planId)] : planByName[opt.value];
                    if (!plan) return;
            
                    const perCents = perDeliveryFor(plan);
                    let pct = plan.price_adjustments?.[0]?.value_type === 'percentage'
                      ? Number(plan.price_adjustments[0].value) || null
                      : (perCents != null && regularCents != null
                          ? Math.round((1 - perCents / regularCents) * 100)
                          : null);
            
                    if (pct != null && perCents != null && regularCents != null) {
                      opt.textContent = `${plan.name} (${pct}% off ${formatMoney(regularCents, moneyFmt)}) — ${formatMoney(perCents, moneyFmt)} / delivery`;
                    }
                  });
                }
            
                root.setAttribute(MARK, '1');
              }
            
              function waitAndUpdate(root, tries = 40) {
                const hasOptions = root.querySelector('.bsub-option-container') || root.querySelector('.bsub-dropdown-select');
                if (hasOptions) { updateLabels(root); return; }
                if (tries <= 0) return;
                setTimeout(() => waitAndUpdate(root, tries - 1), 100);
              }
            
              // Run for existing widgets
              document.querySelectorAll(SCOPE).forEach(el => waitAndUpdate(el));
            
              // Observe future quick-buy drawers opening
              const mo = new MutationObserver(muts => {
                for (const m of muts) {
                  for (const node of m.addedNodes || []) {
                    if (node.nodeType !== 1) continue;
                    if (node.matches?.(SCOPE)) waitAndUpdate(node);
                    node.querySelectorAll?.(SCOPE).forEach(w => waitAndUpdate(w));
                  }
                }
              });
              mo.observe(document.body, { childList: true, subtree: true });
            })();
       